module.exports = __webpack_public_path__ + "img/absoluteValuation.2673a325.png";